import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card } from "react-bootstrap";
import BlogSection from "components/common/sections/BlogSection";
import TryDemoSection from "components/common/sections/TryDemoSection";
import BlogMain from "assets/blog_main_images/GOLDvsREALESTATEvsSTOCKS.jpeg";
import Frame1 from "assets/images/frame-1.png";
import "../Blog/BlogMainLanding.css";

const Blog = () => {
  return (
    <>
      {/* Blog header section */}
      <section id="blog-header-section">
        <Container className="mt-5">
          <Row>
            <Col sm={12} className="text-center mb-2 mb-lg-4">
              <h1>Education Center for Stocks</h1>
              {/*<h1>Personal Communication</h1>*/}
            </Col>
          </Row>
        </Container>
      </section>
      {/* End */}

      {/* Blog section 1 */}
      <section id="blog-section-1">
        <Container className="mt-5">
          <Row>
            <Col sm={12} lg={7} className="text-center ps-0 pe-0 pe-lg-3">
              <a
                className="card-title-blog"
                href="https://fortinves.tech/blog/why-invest-in-stocks-us"
              >
                <img
                  className="w-100 h-100 rounded-3"
                  src={BlogMain}
                  style={{ objectFit: "cover" }}
                  alt="Stocks vs Gold vs Real Estate"
                />
              </a>
            </Col>
            <Col
              sm={12}
              lg={5}
              className="d-flex align-items-center text-left mt-3 mt-lg-0 ps-2 ps-lg-5 bg-white  rounded-3"
            >
              <div className="blog-first-article">
                <a href="https://fortinves.tech/blog/why-invest-in-stocks-us">
                  <h3 style={{ textAlign: "left" }}>
                    Why should you invest in Stocks?
                  </h3>
                  <p style={{ color: "#000000cc", paddingBottom: "20px" }}>
                    Stocks are and always have been the biggest wealth creators
                    and preservers over time. The average stock market return is
                    double of gold and real estate. A healthy combination of
                    stocks, real estate, gold and cash is the right portfolio.
                  </p>
                </a>
                <a href="https://fortinves.tech/blog/why-invest-in-stocks-us">
                  <h5>
                    Read more
                    <i
                      className="bi bi-arrow-right-circle ml-4"
                      style={{ fontSize: "1.5rem", marginLeft: "15px" }}
                    ></i>
                  </h5>
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* End */}

      {/* Blog section 2 */}
      <BlogSection showHeader={false} />

      {/*/!* Blog section 3 *!/*/}
      {/*<section id="blog-section-two-more">*/}
      {/*  <Container className="mt-5">*/}
      {/*    <Row className="gap-4 gap-lg-0">*/}
      {/*      <Col sm={12} lg={6}>*/}
      {/*        <Card className="white-card border-0 mx-auto mb-4 h-100">*/}
      {/*          <Card.Img variant="top" src={Frame1} />*/}
      {/*          <Card.Body>*/}
      {/*            <Card.Title>*/}
      {/*              <h3>What is cryptocurrency?</h3>*/}
      {/*            </Card.Title>*/}
      {/*            <Card.Text>*/}
      {/*              Cryptocurrency is a digital asset that uses encryption*/}
      {/*              techniques to secure transactions and control the creation*/}
      {/*              of new units.*/}
      {/*            </Card.Text>*/}
      {/*            <footer className="mt-4">*/}
      {/*              <h5*/}
      {/*                style={{ fontWeight: "lighter", display: "inline-flex" }}*/}
      {/*              >*/}
      {/*                Read more*/}
      {/*              </h5>*/}
      {/*            </footer>*/}
      {/*          </Card.Body>*/}
      {/*        </Card>*/}
      {/*      </Col>*/}
      {/*      <Col sm={12} lg={6}>*/}
      {/*        <Card className="white-card border-0 mx-auto mb-4 h-100">*/}
      {/*          <Card.Img variant="top" src={Frame1} />*/}
      {/*          <Card.Body>*/}
      {/*            <Card.Title>*/}
      {/*              <h3>Fund your account</h3>*/}
      {/*            </Card.Title>*/}
      {/*            <Card.Text>*/}
      {/*              Cryptocurrency is a digital asset that uses encryption*/}
      {/*              techniques to secure transactions and control the creation*/}
      {/*              of new units.*/}
      {/*            </Card.Text>*/}
      {/*            <footer className="mt-4">*/}
      {/*              <h5*/}
      {/*                style={{ fontWeight: "lighter", display: "inline-flex" }}*/}
      {/*              >*/}
      {/*                Read more*/}
      {/*              </h5>*/}
      {/*            </footer>*/}
      {/*          </Card.Body>*/}
      {/*        </Card>*/}
      {/*      </Col>*/}
      {/*    </Row>*/}
      {/*  </Container>*/}
      {/*</section>*/}
      {/*/!* End *!/*/}

      {/* Try CTA section */}
      <TryDemoSection />
    </>
  );
};

export default Blog;
